import useMemorize from "./useMemorize";
import en from "../utils/lang/en.js";
import heb from "../utils/lang/heb.js";
import { useMemo } from "react";
export default function useLanguage() {
  const [language, setLanguage] = useMemorize("language");
  const content = useMemo(() => ({en, heb}[language] || en), [language]);

  return [content, setLanguage];
}